import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import WebService from "@/components/sections/WebService";
import usePageMeta from "@/lib/usePageMeta";

export default function ServiceWeb() {
  usePageMeta({
    title: "Verkkosivut yritykselle – hinnat ja paketit | MyyntiDrive",
    description: "Kolme verkkosivupakettia yrityksille: Perus 150 €, Kasvu 390 €, Pro 690 €. Kiinteä hinta ja ilmaiset mallisivut ennen ostopäätöstä. Palvelemme koko Suomessa.",
    ogTitle: "Verkkosivut yritykselle – hinnat ja paketit | MyyntiDrive",
    ogDescription: "Kolme verkkosivupakettia yrityksille: Perus 150 €, Kasvu 390 €, Pro 690 € (+ alv 25,5 %). Ilmaiset mallisivut ennen ostoa. Palvelemme koko Suomessa.",
  });

  return (
    <div className="min-h-screen bg-[#0B0D10] text-white" data-testid="service-web-page">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-10">
        <div className="md-container max-w-4xl">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors" data-testid="back-link">
            <ArrowLeft size={16} /> Takaisin etusivulle
          </Link>
          <span className="mt-8 md-eyebrow">Palvelu – Verkkosivut</span>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
            Ammattimaiset <span className="text-[#00E5FF]">verkkosivut.</span>
          </h1>
          <p className="mt-6 text-lg text-white/70 leading-relaxed">
            Kolme selkeää pakettia, kiinteä hinta. Näet mallisivut yrityksellesi ennen kuin maksat euroakaan.
          </p>
        </div>
        <WebService />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
